import { useState } from "react";
import { Coffee, Loader2, LogIn, LogOut, MapPin } from "lucide-react";
import { toast } from "sonner";
import { useI18n } from "../../../i18n";
import { api } from "../../../lib/api";
import { errMsg } from "../../../lib/xutil";
import { Panel, btn, btnGhost } from "../../../components/common/Page";

const locate = () => new Promise((resolve, reject) => {
  if (!navigator.geolocation) { reject(new Error("no_geo")); return; }
  navigator.geolocation.getCurrentPosition((p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude }), reject, { enableHighAccuracy: true, timeout: 15000 });
});

export const ClockCard = ({ me, onChange }) => {
  const { t, lang } = useI18n();
  const [busy, setBusy] = useState(null);
  const e = me.today || {};
  const open = e.breaks?.length && !e.breaks[e.breaks.length - 1].end;
  const state = !e.in ? "none" : e.out ? "done" : open ? "break" : "shift";
  const act = async (action) => {
    setBusy(action);
    try {
      let pos = {};
      if (me.location.enabled) {
        try { pos = await locate(); } catch (err) { toast.error(t("x.err.location_required")); return; }
      }
      const { data } = await api.post("/hr/clock", { action, ...pos });
      toast.success(t("x.hr.clocked", { t: action === "in" ? data.in : action === "out" ? data.out : data.breaks[data.breaks.length - 1]?.[action === "break_start" ? "start" : "end"] }));
      onChange();
    } catch (err) { toast.error(errMsg(t, err)); } finally { setBusy(null); }
  };
  const B = ({ a, icon: Icon, label, cls }) => (
    <button type="button" disabled={!!busy} onClick={() => act(a)} className={`${btn} h-14 flex-1 text-base ${cls}`} data-testid={`clock-${a}`}>
      {busy === a ? <Loader2 className="h-5 w-5 animate-spin" /> : <Icon className="h-5 w-5" />}{label}
    </button>
  );
  const status = { none: t("x.hr.notClocked"), shift: t("x.hr.onShift", { t: e.in }), break: t("x.hr.onBreak", { t: open && e.breaks[e.breaks.length - 1].start }), done: t("x.hr.finished", { a: e.in, b: e.out }) }[state];
  return (
    <Panel testId="clock-card">
      <p className="text-xs font-medium uppercase tracking-wider text-slate-500">{new Intl.DateTimeFormat(lang === "en" ? "en-GB" : "el-GR", { weekday: "long", day: "2-digit", month: "long", timeZone: "Europe/Athens" }).format(new Date())}</p>
      <p className="mt-1 text-2xl font-bold text-navy" data-testid="clock-status">{status}</p>
      <p className="mt-1 flex items-center gap-1 text-xs text-slate-500"><MapPin className="h-3.5 w-3.5" />{me.location.enabled ? t("x.hr.locationOn", { r: me.location.radius_m, label: me.location.label }) : t("x.hr.locationOff")}</p>
      <div className="mt-4 flex flex-wrap gap-2">
        {state === "none" && <B a="in" icon={LogIn} label={t("x.hr.clockIn")} cls="bg-brand text-white" />}
        {state === "shift" && <><B a="break_start" icon={Coffee} label={t("x.hr.breakStart")} cls={btnGhost} /><B a="out" icon={LogOut} label={t("x.hr.clockOut")} cls="bg-navy text-white" /></>}
        {state === "break" && <><B a="break_end" icon={Coffee} label={t("x.hr.breakEnd")} cls="bg-brand text-white" /><B a="out" icon={LogOut} label={t("x.hr.clockOut")} cls="bg-navy text-white" /></>}
      </div>
    </Panel>
  );
};
